import React, { useState } from 'react'
import { getMessage } from 'lib/translator'
import Table, { Cell, Row, Header } from 'components/Table'
import arrow from 'components/Form/Inputs/Select/dropdown arrow.svg'
import { IMG_PLACEHOLDER } from 'components/AppHome/AppLayout/utils'
import './style.scss'

const TableProperties = ({
  index,
  module,
  setCurrentModule,
  setCurrentModuleIndex,
  setTab,
}) => {
  return (
    <Table className="module-table">
      <Header>
        <Cell>{getMessage('app.layout.module.name')}</Cell>
        <Cell>{getMessage('app.layout.module.title')}</Cell>
        <Cell>{getMessage('app.layout.module.status')}</Cell>
      </Header>

      <Row>
        <Cell className="module-name">
          <span
            onClick={() => {
              setCurrentModule(module)
              setCurrentModuleIndex(index)
              setTab(2)
            }}
          >
            {module.mName}
          </span>
        </Cell>
        <Cell>{module.mConfig?.default?.title || '-'}</Cell>
        <Cell className={`module-status module-status-${module.mIsEnable}`}>
          {module.mIsEnable
            ? getMessage('app.layout.enabled')
            : getMessage('app.layout.disabled')}
        </Cell>
      </Row>
    </Table>
  )
}

const Module = ({
  index,
  module,
  setCurrentModule,
  setCurrentModuleIndex,
  setTab,
}) => {
  const [showDetails, setShowDetails] = useState(false)

  return (
    <div className="draggable module">
      <div
        className="module-header"
        onClick={() => setShowDetails((prev) => !prev)}
      >
        <div
          className={`${
            module.mIsEnable ? 'enabled-module' : 'disabled-module'
          }`}
        >
          <h4>{module.mName}</h4>
        </div>
        <span className={`${!showDetails && 'up-arrow'}`}>
          <img src={arrow} alt="Toggle module details" />
        </span>
      </div>
      {showDetails && (
        <div className="module-section">
          <div className="module-placeholder">
            <img
              src={IMG_PLACEHOLDER[module.mType] || IMG_PLACEHOLDER.default}
              alt="module placeholder"
            />
          </div>
          <TableProperties
            index={index}
            module={module}
            setTab={setTab}
            setCurrentModule={setCurrentModule}
            setCurrentModuleIndex={setCurrentModuleIndex}
          />
        </div>
      )}
    </div>
  )
}

export default Module
